import { Grid, TextField } from '@mui/material'
import ModalRequest from '../../../components/ModalRequest'
import { useEffect, useState } from 'react'
import axiosInstance from '../../../config/axiosConfig'
import { urlConfig } from '../../../config/apiConfig'

export default function LineForm({ open, setOpen, row, handleAlert, refresh }) {
    const [loading, setLoading] = useState(false)
    const [data, setData] = useState({
        group_line_id: '',
    })

    const onSubmit = async () => {
        try {
            setLoading(true)
            if (row) {
                await axiosInstance.put(
                    `${urlConfig.lineOA}/keyName/${row.keyName}`,
                    {
                        group_line_id: data.group_line_id,
                    },
                )
                handleAlert('Setting Line OA', 'success')
            }
            setOpen(false)
            refresh()
            // setData({ channel_access_token: '', group_line_id: '' })
            setData({ group_line_id: '' })
        } catch (error) {
            handleAlert(
                error.response?.data?.message || 'Failed to save Line OA',
                'error',
            )
        } finally {
            setLoading(false)
        }
    }

    useEffect(() => {
        if (row) {
            setData(row)
        } else {
            setData({ group_line_id: '' })
        }
    }, [row, open])

    return (
        <ModalRequest
            width='600px'
            disabled={loading}
            open={open}
            setOpen={setOpen}
            title={`Setting Line OA ${row?.keyName}`}
            onSubmit={onSubmit}
        >
            {/* <Grid item xs={12} mt={1}>
                <TextField
                    size='small'
                    fullWidth
                    label='Channel Access Token'
                    name='channel_access_token'
                    value={data?.channel_access_token || ''}
                    onChange={(e) =>
                        setData({
                            ...data,
                            channel_access_token: e.target.value,
                        })
                    }
                />
            </Grid>{' '} */}
            <Grid item xs={12}>
                <TextField
                    size='small'
                    fullWidth
                    label='Group/User ID'
                    name='group_line_id'
                    value={data?.group_line_id || ''}
                    onChange={(e) =>
                        setData({
                            ...data,
                            group_line_id: e.target.value,
                        })
                    }
                />
            </Grid>
        </ModalRequest>
    )
}
